import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GroupListItem from './GroupListItem';

class GroupList extends React.Component {
  static propTypes = {
    groups: PropTypes.array,
    currentSelection: PropTypes.object,
    selectGroup: PropTypes.func
  };

  selectGroup(group) {
    const { selectGroup } = this.props;
    selectGroup(group);
  }

  renderGroups() {
    let groupItems = [];
    const { currentSelection, groups } = this.props;
    if (groups) {
      groups.forEach((group, index) => {
        groupItems.push(
          <GroupListItem
            group={group}
            key={index}
            position={index}
            currentSelection={currentSelection}
            selectGroup={this.selectGroup.bind(this, group.id)}
          />
        );
      });
    }
    return groupItems;
  }

  render() {
    return <div className="carousel">{this.renderGroups()}</div>;
  }
}

export default connect()(GroupList);
